import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

class Link extends PureComponent {
  render() {
    const { to, children, openInNewWindow, ...rest } = this.props;

    const target = openInNewWindow ? '_blank' : '_self';
    const norel = openInNewWindow ? 'noopener noreferrer' : '';
    if (!to) {
      return <span {...rest}>{children}</span>;
    }

    if (/^https?:\/\//.test(to) || /^mailto:/.test(to) || /^tel:/.test(to)) {
      return (
        <a href={to} target={target} rel={norel} {...rest}>
          {children}
        </a>
      );
    }

    if (typeof window !== 'undefined') {
      // replace empty hash links to avoid issues with react-router-hash-link.
      if (to === '#') {
        return (
          <span {...rest} style={{ cursor: 'pointer ' }}>
            {children}
          </span>
        );
      }
      return (
        <HashLink
          smooth
          to={to}
          target={target}
          {...rest}
          scroll={el =>
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'start'
            })
          }
        >
          {children}
        </HashLink>
      );
    }

    return (
      <RouterLink to={to} target={target} {...rest}>
        {children}
      </RouterLink>
    );
  }
}

Link.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node
};

export default Link;
